import { render, staticRenderFns } from "./ImageItem3Template.vue?vue&type=template&id=3dcca4c5"
import script from "./ImageItem3Template.vue?vue&type=script&lang=js"
export * from "./ImageItem3Template.vue?vue&type=script&lang=js"
import style0 from "./ImageItem3Template.vue?vue&type=style&index=0&id=3dcca4c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports